import React, { useState, useEffect } from 'react';
import Dictionary from "./Dictionary.js";
import './styles.css';

function Square({ value }) {
  return (
    <div className="cubie">
      <span>{value}</span>
    </div>
  );
}

function Board({ board }) {
  // Create flat array of 36 positions
  const cells = [];
  for (let i = 0; i < 6; i++) {
    for (let j = 0; j < 6; j++) {
      cells.push([i, j]);
    }
  }

  return (
    <div className="board">
      {cells.map((cell) => (
        <Square 
          value={board[""+cell[0]+cell[1]]} 
          key={""+cell[0]+cell[1]} 
        />
      ))}
    </div>
  );
}

function WordCountDisplay({ wordsByLength }) {
  const lengths = Object.keys(wordsByLength);
  lengths.sort((a, b) => a - b);
  
  return (
    <div className="word-count">
      {lengths.map(length => (
        <div key={length} className="word-count-item">
          <div className="length-container">
            <span className="word-length">{length}</span>
          </div>
          <span className="word-count-number">{wordsByLength[length].length}</span>
        </div>
      ))}
    </div>
  );
}

function SeededRandom(seed) {
  this.seed = seed % 2147483647;
  if (this.seed <= 0) this.seed += 2147483646;
}

SeededRandom.prototype.next = function () {
  return this.seed = this.seed * 16807 % 2147483647;
};

SeededRandom.prototype.nextDouble = function () {
  return (this.next() - 1) / 2147483646;
};

function generateBoard(cubes, dictionary, num_boards, rng) {
  var best_board = null;
  var best_score = 0;

  for (let k = 0; k < num_boards; k++) {
    let board = {};

    let cubeOrder = [];
    for (let i = 0; i < 36; i++) {
      cubeOrder.push(i);
    }
    for (let i = cubeOrder.length - 1; i > 0; i--) {
      let j = Math.floor(rng.nextDouble() * (i + 1));
      let temp = cubeOrder[i];
      cubeOrder[i] = cubeOrder[j];
      cubeOrder[j] = temp;
    }

    let index = 0;
    for (let i = 0; i < 6; i++) {
      for (let j = 0; j < 6; j++) {
        let choice = Math.floor(rng.nextDouble() * 6);
        let letter = cubes[cubeOrder[index]][choice];
        board[""+i+j] = letter;
        index += 1;
      }
    }

    let words = findDaWordies(board, dictionary);
    var score = 0;
    for (let i = 0; i < words.length; i++) {
      score += scoreForWord(words[i]);
    }

    if (score > best_score) {
      best_score = score;
      best_board = board;
    }
  }
  
  return best_board;
}

function recursiveSearch(board, valid, cur, curi, curj, dictionary, words, word) {
  valid[cur] = false;
  let cur_char = board[cur].toLowerCase();

  if (cur_char.length > 1) {
    dictionary = dictionary[cur_char[0]];
    word += cur_char[0];
    cur_char = cur_char[1];
  }

  dictionary = dictionary[cur_char];
  word += cur_char;

  if ('valid' in dictionary && !words.includes(word)) {
    words.push(word);
  }

  for (let ii = -1; ii < 2; ii++) {
    let i = ii + curi;
    if (i < 0 || i > 5) {
      continue;
    }
    for (let jj = -1; jj < 2; jj++) {
      let j = jj + curj;
      if (j < 0 || j > 5) {
        continue;
      }
      let lookup = ''+i+j;
      if (valid[lookup] === false) {
        continue;
      }
      let char = board[lookup].toLowerCase();
      if (char.length > 1) {
        if (char[0] in dictionary && char[1] in dictionary[char[0]]) {
          recursiveSearch(board, valid, ''+i+j, i, j, dictionary, words, word);
        }
      } else if (char in dictionary) {
        recursiveSearch(board, valid, ''+i+j, i, j, dictionary, words, word);
      }
    }
  }
  valid[cur] = true;
}

function scoreForWord(word) {
  if (word.length === 5) {
    return 2;
  } else if (word.length === 6) {
    return 3;
  } else if (word.length === 7) {
    return 5;
  } else if (word.length === 8) {
    return 11;
  } else if (word.length === 9) {
    return 15;
  } else if (word.length === 10) {
    return 20;
  } else if (word.length === 11) {
    return 30;
  } else if (word.length === 12) {
    return 40;
  } else if (word.length === 13) {
    return 50;
  } else {
    return 100;
  }
}

function findDaWordies(board, dictionary) {
  let words = [];
  let valid = {};
  for (let i = 0; i < 6; i++) {
    for (let j = 0; j < 6; j++) {
      valid[''+i+j] = true;
    }
  }
  for (let i = 0; i < 6; i++) {
    for (let j = 0; j < 6; j++) {
      recursiveSearch(board, valid, ''+i+j, i, j, dictionary, words, '');
    }
  }
  return words;
}

function Game() {
  // Initial constants
  const cubes = [
    ['A','A','A','F','R','S'],
    ['A','A','E','E','E','E'],
    ['A','A','E','E','O','O'],
    ['A','A','F','I','R','S'],
    ['A','B','D','E','I','O'],
    ['A','D','E','N','N','N'],
    ['A','E','E','E','E','M'],
    ['A','E','E','G','M','U'],
    ['A','E','G','M','N','N'],
    ['A','E','I','L','M','N'],
    ['A','E','I','N','O','U'],
    ['A','F','I','R','S','Y'],
    ['An','Er','He','In','Qu','Th'],
    ['B','B','J','K','X','Z'],
    ['C','C','E','N','S','T'],
    ['C','D','D','L','N','N'],
    ['C','E','I','I','T','T'],
    ['C','E','I','P','S','T'],
    ['C','F','G','N','U','Y'],
    ['D','D','H','N','O','T'],
    ['D','H','H','L','O','R'],
    ['D','H','H','N','O','W'],
    ['D','H','L','N','O','R'],
    ['E','H','I','L','R','S'],
    ['E','I','I','L','S','T'],
    ['E','I','L','P','S','T'],
    ['E','I','O','R','S','E'],
    ['E','M','T','T','T','O'],
    ['E','N','S','S','S','U'],
    ['G','O','R','R','V','W'],
    ['H','I','R','S','T','V'],
    ['H','O','P','R','S','T'],
    ['I','P','R','S','Y','Y'],
    ['J','K','Qu','W','X','Z'],
    ['N','O','O','T','U','W'],
    ['O','O','O','T','T','U']
  ];
  
  const initialSeed = 42;
  const root_dictionary = Dictionary;

  // State variables
  const [board, setBoard] = useState({});
  const [words, setWords] = useState([]);
  const [wordsByLength, setWordsByLength] = useState({});
  const [foundWords, setFoundWords] = useState([]);
  const [score, setScore] = useState(0);
  const [seed, setSeed] = useState(initialSeed);
  const [boardCount, setBoardCount] = useState(0); // Track number of "New Board" clicks
  const [rng, setRng] = useState(new SeededRandom(initialSeed));
  const [inputText, setInputText] = useState("");
  const [displayTip, setDisplayTip] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Initialize the game
  useEffect(() => {
    // Reset board count when seed changes
    setBoardCount(0);
    
    // Generate initial board for this seed
    generateNewBoard(seed, 0);
  }, [seed]);
  
  // Function to generate a new board based on seed and count
  const generateNewBoard = (seedValue, count) => {
    // Create a deterministic initial RNG based on seed
    const baseRng = new SeededRandom(seedValue);
    
    // Advance the RNG based on board count
    for (let i = 0; i < count * 100; i++) {
      baseRng.nextDouble();
    }
    
    // Generate the board with the prepared RNG
    const newBoard = generateBoard(cubes, root_dictionary, 50, baseRng);
    const newWords = findDaWordies(newBoard, root_dictionary);
    
    const newWordsByLength = {};
    for (let word of newWords) {
      if (!(word.length in newWordsByLength)) {
        newWordsByLength[word.length] = [];
      }
      newWordsByLength[word.length].push(word);
    }
    
    setBoard(newBoard);
    setWords(newWords);
    setWordsByLength(newWordsByLength);
    setFoundWords([]);
    setScore(0);
    setDisplayTip(null);
  };

  // Window resize handler
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const reshuffle = () => {
    // Increment the board count to get the next board for this seed
    const nextBoardCount = boardCount + 1;
    setBoardCount(nextBoardCount);
    
    // Generate a new board using the same seed but advanced count
    generateNewBoard(seed, nextBoardCount);
    setInputText("");
  };

  const updateInput = (event) => {
    let word = event.target.value;
    
    if (word.includes('\n')) {
      word = word.toLowerCase().trim();
      
      if (!words.includes(word)) {
        setDisplayTip(`${word} is not a valid word`);
      } else if (foundWords.includes(word)) {
        setDisplayTip(`You already added ${word}`);
      } else {
        const newFoundWords = [...foundWords, word];
        const newScore = score + scoreForWord(word);
        const newWordsByLength = {...wordsByLength};
        
        newWordsByLength[word.length].splice(newWordsByLength[word.length].indexOf(word), 1);
        
        setFoundWords(newFoundWords);
        setScore(newScore);
        setWordsByLength(newWordsByLength);
        setDisplayTip(`Added ${word}`);
      }
      setInputText("");
    } else {
      setInputText(word);
    }
  };

  const updateSeed = (event) => {
    const newSeed = parseInt(event.target.value) || initialSeed;
    setSeed(newSeed);
    // The RNG will be updated by the useEffect that watches seed changes
  };

  return (
    <div className="game parent">
      <div className="col1">
        <div className="chart">
          <div>Remaining Words by Length</div>
          <WordCountDisplay wordsByLength={wordsByLength} />
          <div className="seed-container">
            <textarea 
              value={seed} 
              onChange={updateSeed} 
              placeholder="Random Seed"
              className="seed-input"
            />
          </div>
        </div>
      </div>

      <div className="col2">
        <h1>Max + Kendra's Boggle Board</h1>
        <div className="score">Score: {score}</div>
        <Board board={board} />
        <div className="answer">{displayTip}</div>
        <form>
          <textarea 
            value={inputText} 
            onChange={updateInput} 
            placeholder="Enter your word"
          />
        </form>
        <button className="reshuffle-button" onClick={reshuffle}>
          New Board
        </button>
      </div>

      <div className="col3">
        <div className="entered-word">
          {foundWords.join(', ')}
        </div>
      </div>

      {isMobile && (
        <div className="mobile-container">
          <div className="entered-word">
            {foundWords.join(', ')}
          </div>
          <div className="chart">
            <div>Remaining Words by Length</div>
            <WordCountDisplay wordsByLength={wordsByLength} />
            <div className="seed-container">
              <textarea 
                value={seed} 
                onChange={updateSeed} 
                placeholder="Random Seed"
                className="seed-input"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Game;